var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForearm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "36px",
    viewBox: "0 0 83 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Forearm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-14",
    transform: "translate(-47.000000, -165.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4382325,165 C59.1168492,173.355195 58.2375258,179.622673 57.8002623,183.802433 C57.3629988,187.982194 56.9869483,193.714716 56.6721108,201 L49.1061151,201 C50.1315083,200.729876 50.5266846,197.636172 50.2916439,191.718889 C49.1936627,184.878326 48.3218338,175.972029 47.6761574,165 L60.4382325,165 Z M129.438233,165 C128.792556,175.972029 127.920727,184.878326 126.822746,191.718889 C126.587705,197.636172 126.982882,200.729876 128.008275,201 L128.008275,201 L120.442279,201 C120.127442,193.714716 119.751391,187.982194 119.314128,183.802433 C118.876864,179.622673 117.997541,173.355195 116.676157,165 L116.676157,165 Z",
    id: "Forearm"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForearm);
export default __webpack_public_path__ + "static/media/Forearm.e48ea60a713424193869e381284fd175.svg";
export { ForwardRef as ReactComponent };